module.exports = __webpack_public_path__ + "img/pantalla-7-5.7a64ffd2.png";